<!-- Dynamic search fields based on master data layout -->
<div class="search-grid" [style.grid-template-columns]="getSearchGridTemplateColumns()">
  <ng-container *ngFor="let position of searchablePositions">

    <!-- HR element (divider) or deprecated address field (rendered as HR) -->
    <div
      *ngIf="position.fieldType === 'hr' || position.fieldKey === 'address'"
      class="hr-cell"
      [style.grid-column]="getSearchGridColumn(position)"
      [style.grid-row]="getSearchGridRow(position)"
    >
      <hr>
    </div>

    <!-- Standard field (except address which is rendered as HR) -->
    <ng-container *ngIf="position.fieldType === 'standard' && position.fieldKey !== 'address'">
      <div class="search-field"
           [style.grid-column]="getSearchGridColumn(position)"
           [style.grid-row]="getSearchGridRow(position)">
        <label>{{getSearchFieldLabel(position)}}</label>

        <!-- Gender dropdown -->
        <select *ngIf="position.fieldKey === 'gender'" class="form-control" [(ngModel)]="filter.gender"
                (change)="onFilterChange()">
          <option value="">--</option>
          <option value="male">{{_(KEYS.SEARCH.MALE)}}</option>
          <option value="female">{{_(KEYS.SEARCH.FEMALE)}}</option>
          <option value="diverse">{{_(KEYS.SEARCH.DIVERSE)}}</option>
        </select>

        <!-- Allow Mail dropdown -->
        <select *ngIf="position.fieldKey === 'allowMail'" class="form-control" [(ngModel)]="filter.allowMail"
                (change)="onFilterChange()">
          <option value="">--</option>
          <option value="true">{{_(KEYS.SEARCH.YES)}}</option>
          <option value="false">{{_(KEYS.SEARCH.NO)}}</option>
        </select>

        <!-- Prefill dropdown -->
        <select *ngIf="position.fieldKey === 'prefill'" class="form-control" [(ngModel)]="filter.prefill"
                (change)="onFilterChange()">
          <option value="">--</option>
          <option value="yes">{{_(KEYS.SEARCH.YES)}}</option>
          <option value="no">{{_(KEYS.SEARCH.NO)}}</option>
          <option value="optional">{{_(KEYS.SEARCH.OPTIONAL)}}</option>
        </select>

        <!-- Locale dropdown -->
        <select *ngIf="position.fieldKey === 'locale'" class="form-control" [(ngModel)]="filter.locale"
                (change)="onFilterChange()">
          <option value="">--</option>
          <ng-container *ngFor="let loc of objectKeys(languages)">
            <option [value]="loc">{{translateLanguage(languages[loc])}}</option>
          </ng-container>
        </select>

        <!-- Text input for other standard fields -->
        <input *ngIf="!isDropdownField(position.fieldKey)" class="form-control"
               [(ngModel)]="filter[position.fieldKey]"
               (paste)="onFilterChange()" (change)="onFilterChange()" (keydown)="onFilterChange()">
      </div>
    </ng-container>

    <!-- Custom field -->
    <ng-container *ngIf="position.fieldType === 'custom'">
      <ng-container *ngIf="getCustomFieldDefinition(position.fieldKey) as def">
        <div class="search-field"
             [style.grid-column]="getSearchGridColumn(position)"
             [style.grid-row]="getSearchGridRow(position)">
          <label>{{def.label}}</label>

          <!-- Dropdown for select type -->
          <select *ngIf="def.type === 'select'" class="form-control"
                  [(ngModel)]="customFilter[position.fieldKey]" (change)="onFilterChange()">
            <option value="">--</option>
            <option *ngFor="let opt of def.options" [value]="opt.value">{{opt.label}}</option>
          </select>

          <!-- Boolean dropdown -->
          <select *ngIf="def.type === 'boolean'" class="form-control"
                  [(ngModel)]="customFilter[position.fieldKey]" (change)="onFilterChange()">
            <option value="">--</option>
            <option value="true">{{_(KEYS.SEARCH.YES)}}</option>
            <option value="false">{{_(KEYS.SEARCH.NO)}}</option>
          </select>

          <!-- Text input for other types -->
          <input *ngIf="def.type !== 'select' && def.type !== 'boolean'" class="form-control"
                 [(ngModel)]="customFilter[position.fieldKey]"
                 (paste)="onFilterChange()" (change)="onFilterChange()" (keydown)="onFilterChange()">
        </div>
      </ng-container>
    </ng-container>

  </ng-container>
</div>

<!-- Slot for grid-specific extra fields (e.g. meta-filter, status) -->
<ng-content select="[extraFields]"></ng-content>
